var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import searchPopupTemplate from 'text!./partials/SearchPopup.html';

var RepairFacilitySelectorCtrl = function () {
    function RepairFacilitySelectorCtrl(MediaQueriesUtil, ModalService) {
        _classCallCheck(this, RepairFacilitySelectorCtrl);

        this.ModalService = ModalService;
        this.phoneLandscapeDownQuery = MediaQueriesUtil.getPhoneLandscapeDownQuery();
        this.mobileView = this.phoneLandscapeDownQuery.matches;
        this.mobileBreakpointListener = null;
        this.searchPopup = null;
        this.popupModel = {};
    }

    _createClass(RepairFacilitySelectorCtrl, [{
        key: '$onInit',
        value: function $onInit() {
            if (this.selectedRepairFacility) {
                this.handleMobilePopup(this.selectedRepairFacility);
            }
        }
    }, {
        key: 'selectFacility',
        value: function selectFacility(facility) {
            this.onFacilitySelect({ facility: facility });
            this.handleMobilePopup(facility);

            if (facility) {
                this.onSearchWaypointChange({ coords: facility.primaryAddress.spatialPoint });
            }
        }
    }, {
        key: 'handleMobilePopup',
        value: function handleMobilePopup(facility) {
            var _this = this;

            if (this.mobileView) {
                this.searchPopup = this.openSearchPopup(facility);
            }

            if (!this.mobileBreakpointListener) {
                this.mobileBreakpointListener = function (event) {
                    if (event.matches) {
                        if (!_this.searchPopup) {
                            _this.searchPopup = _this.openSearchPopup(facility);
                        }
                    } else {
                        _this.searchPopup.close();
                        _this.searchPopup = null;
                    }
                };
                this.phoneLandscapeDownQuery.addListener(this.mobileBreakpointListener);
            }
        }
    }, {
        key: 'openSearchPopup',
        value: function openSearchPopup(facility) {
            var _this2 = this;

            if (facility) {
                this.popupModel.selectVendor = Promise.resolve(facility);
                this.popupModel.enableSearch = false;
            } else {
                this.popupModel.selectVendor = null;
                this.popupModel.enableSearch = true;
            }

            this.popupModel.selectedFacility = facility;
            this.popupModel.repairFacilities = this.repairFacilities;
            this.popupModel.searchCenter = facility ? facility.primaryAddress.spatialPoint : this.searchCenter;
            this.popupModel.onSearchWaypointChange = this.onSearchWaypointChange;
            this.popupModel.onRepairFacilitiesRefresh = this.onRepairFacilitiesRefresh;
            this.popupModel.facilitySelected = this.onFacilitySelect;

            this.popupModel.policyLocation = this.policyLocation;
            this.popupModel.lossLocation = this.lossLocation;
            this.popupModel.myLocation = this.myLocation;
            this.popupModel.selectStaticAddress = this.selectStaticAddress;

            var modal = this.ModalService.showFullScreenPopup(searchPopupTemplate, this.popupModel, { fixedScroll: true });
            modal.result.then(function () {
                // set null when destroyed
                _this2.searchPopup = null;
            });
            return modal;
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            if (this.phoneLandscapeDownQuery && this.mobileBreakpointListener) {
                this.phoneLandscapeDownQuery.removeListener(this.mobileBreakpointListener);
            }
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(_ref) {
            var _this3 = this;

            var selectedRepairFacility = _ref.selectedRepairFacility,
                repairFacilities = _ref.repairFacilities,
                policyLocation = _ref.policyLocation,
                lossLocation = _ref.lossLocation,
                myLocation = _ref.myLocation,
                searchCenter = _ref.searchCenter;

            if (selectedRepairFacility && selectedRepairFacility.currentValue && selectedRepairFacility.currentValue !== selectedRepairFacility.previousValue) {
                this.popupModel.selectedFacility = selectedRepairFacility.currentValue;
            }

            if (repairFacilities && repairFacilities.currentValue && repairFacilities.currentValue !== repairFacilities.previousValue) {
                this.popupModel.repairFacilities = repairFacilities.currentValue;

                var sameAsSelectedRepairFacility = function sameAsSelectedRepairFacility(facility) {
                    return facility.addressBookUID === _this3.selectedRepairFacility.addressBookUID;
                };
                if (this.selectedRepairFacility && !repairFacilities.currentValue.some(sameAsSelectedRepairFacility)) {
                    this.onFacilitySelect(null);
                }
            }

            if (policyLocation && policyLocation.currentValue && policyLocation.currentValue !== policyLocation.previousValue) {
                this.popupModel.policyLocation = policyLocation.currentValue;
            }

            if (lossLocation && lossLocation.currentValue && lossLocation.currentValue !== lossLocation.previousValue) {
                this.popupModel.lossLocation = lossLocation.currentValue;
            }

            if (myLocation && myLocation.currentValue && myLocation.currentValue !== myLocation.previousValue) {
                this.popupModel.myLocation = myLocation.currentValue;
            }

            if (searchCenter && searchCenter.currentValue && searchCenter.currentValue !== searchCenter.previousValue) {
                if (this.searchPopup) {
                    // update changes for opened map in popup
                    this.popupModel.searchCenter = searchCenter.currentValue;
                } else if (this.mobileView && searchCenter.previousValue) {
                    // call to reload vendors after static location selected on mobile
                    this.onRepairFacilitiesRefresh(searchCenter.currentValue, null);
                }
            }
        }
    }]);

    return RepairFacilitySelectorCtrl;
}();

RepairFacilitySelectorCtrl.$inject = ['MediaQueriesUtil', 'ModalService'];
export default RepairFacilitySelectorCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/pa/components/RepairFacilitySelector/RepairFacilitySelectorCtrl.js
// module id = 1574
// module chunks = 0